__turbopack_context__.v({
  "checkboxGroup": "CheckboxGroup-module__q-CdOq__checkboxGroup",
  "fieldError": "CheckboxGroup-module__q-CdOq__fieldError",
  "label": "CheckboxGroup-module__q-CdOq__label",
});
